const PRODUCT_INFO_SHEET_UPLOAD_LIMIT_BYTES = 10 * 1024 * 1024;
const SUPPORTED_PRODUCT_INFO_SHEET_TYPES = new Set(["application/pdf"]);

export const PRODUCT_INFO_SHEET_INPUT_ACCEPT = "application/pdf,.pdf";
export const PRODUCT_INFO_SHEET_HELP_TEXT = "Max 10MB. PDF only. Uploaded files are stored in R2.";
export const PRODUCT_INFO_SHEET_TOO_LARGE_MESSAGE =
  "Info sheet is too large. Please choose a PDF file under 10MB.";
export const PRODUCT_INFO_SHEET_INVALID_TYPE_MESSAGE = "Please select a PDF info sheet.";

function isSupportedProductInfoSheetType(file: File): boolean {
  const contentType = file.type.trim().toLowerCase();
  const hasPdfExtension = file.name.trim().toLowerCase().endsWith(".pdf");
  return SUPPORTED_PRODUCT_INFO_SHEET_TYPES.has(contentType) || hasPdfExtension;
}

export function validateProductInfoSheetFile(file: File): string | null {
  if (!isSupportedProductInfoSheetType(file)) {
    return PRODUCT_INFO_SHEET_INVALID_TYPE_MESSAGE;
  }

  if (file.size > PRODUCT_INFO_SHEET_UPLOAD_LIMIT_BYTES) {
    return PRODUCT_INFO_SHEET_TOO_LARGE_MESSAGE;
  }

  return null;
}

export async function prepareProductInfoSheetForUpload(file: File): Promise<{
  fileData: ArrayBuffer;
  filename: string;
  contentType: string;
  size: number;
}> {
  const validationError = validateProductInfoSheetFile(file);
  if (validationError) {
    throw new Error(validationError);
  }

  return {
    fileData: await file.arrayBuffer(),
    filename: file.name.trim() || "product-info-sheet.pdf",
    contentType: "application/pdf",
    size: file.size,
  };
}
